module.exports = __webpack_public_path__ + "img/check-mark.17cf4a9e.svg";